/*
 * VULCAN
 */
import { __extends } from "tslib";
import * as msRest from "@azure/ms-rest-js";
var packageName = "@vulcan/portal-api-client";
var packageVersion = "1.3.0";
var PortalContext = /** @class */ (function (_super) {
    __extends(PortalContext, _super);
    /**
     * Initializes a new instance of the PortalContext class.
     * @param credentials Subscription credentials which uniquely identify client subscription.
     * @param [options] The parameter options
     */
    function PortalContext(credentials, options) {
        var _this = this;
        if (credentials === null || credentials === undefined) {
            throw new Error('\'credentials\' cannot be null.');
        }
        if (!options) {
            options = {};
        }
        if (!options.userAgent) {
            var defaultUserAgent = msRest.getDefaultUserAgentValue();
            options.userAgent = packageName + "/" + packageVersion + " " + defaultUserAgent;
        }
        _this = _super.call(this, credentials, options) || this;
        _this.baseUri = options.baseUri || _this.baseUri || "https://portal-api.dev.vulcansteel.co.nz";
        _this.requestContentType = "application/json; charset=utf-8";
        _this.credentials = credentials;
        return _this;
    }
    return PortalContext;
}(msRest.ServiceClient));
export { PortalContext };
//# sourceMappingURL=portalContext.js.map